// extracted by mini-css-extract-plugin
export default {"fakeDisabled":"JoinProjectButton_fakeDisabled__vV5xT"};